import React, { useState } from 'react'
import styles from "../../pages/pages.module.scss";
import ButtonShapped from '../ButtonShapped';
import { AIAcnt } from "../../utils/assets";

const AIAccountingSection = () => {

  const [activeTab, setActiveTab] = useState(AIAcnt[0]?.id);

  const activeTabData = AIAcnt.find((tab) => tab.id === activeTab) || {};

  return (
    <section >
      <div className="container SectionMTop" >
        <div className={`mb-5 ${styles.sectionheading}`}>
          <ButtonShapped
            text="AI accounting"
            type="primaryshaped"
          />

          <h3>Don’t let the old way of doing things hold you back</h3>
          <p>With our software plus services approach for Next-Gen businesses</p>
        </div>

        <div className={`${styles.bgDark} row mt-5 row-gap-4`}>
          <div className="col-12 col-lg col-xl-6">
            <div className={styles.cardMainHeading}>
              <div>
                <h4 className="mb-3">{activeTabData.title}</h4>
                <p>{activeTabData.description}</p>
              </div>

              <nav className={`${styles.navbarwrapper}`}>
                <div className={`nav nav-tabs ${styles.sectiontabs}`} role="tablist">
                  {AIAcnt.map((tab) => (
                    <button
                      key={tab.id}
                      className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                      onClick={() => setActiveTab(tab.id)}
                      type="button"
                    >
                      {tab.tabName}
                    </button>
                  ))}
                </div>
              </nav>
            </div>
          </div>

          <div className="col-12 col-lg col-xl-6 align-self-center">
            <div className={styles.toolaHReal}>
              {activeTabData.type === "image" ?
                (<img src={activeTabData.content} alt={activeTabData.title} className="img-fluid" />) : (activeTabData.content)
              }
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default AIAccountingSection;